import styled from 'styled-components';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//helpers
import { screen } from '@/helpers/screen';

export const LanguageSelector = styled.div`
  position: relative;
  width: fit-content;

  ${screen.md} {
    margin-top: 30px;
  }
  ${screen.xxlg} {
    margin-top: 50px;
  }
`;

export const LanguageWrapper = styled.div`
  position: relative;
`;

export const LanguageSelectorButton = styled.div`
  display: flex;
  justify-content: space-between;
  alig-items: center;
  margin: auto;
  min-width: 150px;
  max-width: max-content;
  padding: 4px 12px;
  border-radius: 4px;
  border: 1px solid rgb(${getToken('color-text-primary')});
  background: transparent;
  color: rgb(${getToken('color-text-primary')});
  cursor: pointer;
  font-family: ${getToken('font-family-default')};
  font-weight: ${getToken('font-weight-regular')};
  font-size: 14px;
  line-height: 22.4px;

  span {
    padding: 8px 12px;
  }
`;

export const LanguageList = styled.div`
  display: none;
  flex-direction: column;
  gap: 2px;
  position: absolute;
  right: 0;
  top: calc(100% + 4px);
  width: 100%;
  max-width: 200px;
  background: rgb(${getToken('color-background-primary')});
  border: 1px solid rgb(${getToken('color-text-primary')});
  border-radius: 4px;

  &.open {
    display: flex;
  }
`;
export const LanguageOption = styled.div`
  display: flex;
  width: 100%;
  padding: 8px 12px;
  justify-content: space-between;
  text-decoration: none;
  font-family: ${getToken('font-family-default')};
  font-weight: ${getToken('font-weight-regular')};
  font-size: 14px;
  line-height: 22.4px;

  span {
    padding: 6px 12px;
  }
`;
